/**
 * Plan seed text
 *
 * Turns an existing epic into the initiative text a Plan intake starts from
 * (FLOW-614), so breaking down an epic that already exists doesn't mean
 * re-typing what it already says.
 */

import type { WorkItem } from "../api/types";

/**
 * Server bound on `initiative_text` (`StartIntakeRequest`). A description can
 * be far longer than this, so a seed built from a large epic has to be cut or
 * the submit fails validation before the user has typed anything.
 */
const MAX_INITIATIVE_TEXT = 8000;

const TRUNCATION_MARKER = "\n\n…(trimmed to fit — see the epic for the rest)";

/** Initiative text that seeds a Plan intake from an existing epic. */
export function epicSeedText(epic: WorkItem): string {
  const description = epic.description?.trim();
  const scope = epic.type_context?.scope_notes?.trim();

  const text = [
    "Break down this existing epic into stories and tasks.",
    `Epic: ${epic.title.trim()}`,
    description || undefined,
    scope ? `Scope notes:\n${scope}` : undefined,
  ]
    .filter(Boolean)
    .join("\n\n");

  if (text.length <= MAX_INITIATIVE_TEXT) return text;

  return (
    text.slice(0, MAX_INITIATIVE_TEXT - TRUNCATION_MARKER.length).trimEnd() +
    TRUNCATION_MARKER
  );
}
